"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesListPreviewWrapper = void 0;
exports.CompaniesListPreview = CompaniesListPreview;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const useConfig_1 = require("@src/hooks/useConfig");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const Api = __importStar(require("@src/api/company"));
const CompaniesListGrid_1 = require("./CompaniesListGrid");
exports.CompaniesListPreviewWrapper = styled_components_1.default.div `
	width: 100%;
	padding: 5em 0;
	margin: 0 auto;

	h2 {
		font-size: 2em;
		text-align: center;
		font-weight: 700;
		margin: 0 0 2em;
		color: ${props => props.theme.color.brand4};
	}

	h3 {
		font-weight: 400;
		font-size: 1.5em;
		text-align: center;
		margin: 0;

		strong {
			color: ${props => props.theme.color.brand2};
		}
	}
`;
function CompaniesListPreview() {
    const config = (0, useConfig_1.useConfig)();
    const { data: companies, isLoading } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.companiesListPreview.key, {
        limit: config.companies.listPreviewCount,
    }, []);
    const { data: companiesCount } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getCompaniesCount, () => Api.getAllCompaniesCount());
    return ((0, jsx_runtime_1.jsx)(exports.CompaniesListPreviewWrapper, { children: (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.clients.headilne" }) }), (0, jsx_runtime_1.jsx)(CompaniesListGrid_1.CompaniesListGrid, { companies: companies || [], isLoading: isLoading })] }) }));
}
